<template>
<li class="sidebar-popup-category">
  <router-link
    :to="getCategoryRoute(category)"
    @click.native="setSidebarState(false)"
    class="sidebar-popup-category__link"
  >{{ category.name }}</router-link>
  <ul
    v-if="hasChildren"
    class="sidebar-popup-category__children"
  >
    <sidebar-popup-category v-for="child in category.children" :category="child" :key="child.id"/>
  </ul>
</li>
</template>

<script>
import { mapMutations } from 'vuex';
import getCategoryRoute from '../getCategoryRoute';

export default {
  name: 'sidebar-popup-category', // Required so it can render recursively.
  props: {
    category: {
      required: true,
      type: Object,
    },
  },
  computed: {
    hasChildren() {
      return this.category.children?.length > 0;
    },
  },
  methods: {
    ...mapMutations({
      setSidebarState: "ui/setSidebarState"
    }),
    getCategoryRoute,
  },
};
</script>

<style lang="less">
.sidebar-popup-category {
  @apply my-1 text-sm font-light;
  &__link {
    @apply py-1 flex;
    &:before {
      content: '—';
      @apply mr-1;
    }
    &:focus, &:hover, &.router-link-active {
      @apply text-primary outline-none;
    }
  }
  &__children {
    @apply ml-4;
    flex-basis: 100%;
  }
}
</style>
